(function() {
  var myVar = setInterval(timer, 500);
  function timer() {
    if (window.$) {
      $(document).ready(function() {
        $(document).on("swell:setup", function() {
          if(spapi.authenticated) {
            SwellConfig.Redemption.cartRedemptions("#swell-redemption-options");
            SwellConfig.Redemption.cartRedemptionDropdown("#swell-redemption-options");
            SwellConfig.Redemption.cartRedemptionsShow();
            $(".swell-ring-cart").remove();
            var cartTotal = parseInt($("#swell-cart-total").text());
            $('body').on('click', '#swell-redeem-btn', function() {
              $(".swell-copuon-error").hide();
              if(spapi.authenticated) {
                redemptionOptionId = parseInt($("#swell-redemption-options").val());
                redemptionOption = swellAPI.findActiveRedemptionOptionById(redemptionOptionId);
                if(redemptionOption.discount_type == "cart_fixed_amount") {
                  if(beforeDiscountRedemption()) {
                    $(document).on("swell:cart:updated", function() {
                      if(window.location.href.indexOf("cart") > -1) {
                        window.location = "/cart";
                      }
                    });
                    $("#swell-redeem-btn .btn__content").hide();
                    $(".swell-lds-holder.swell-ring-btn").css("display","flex");
                    swellAPI.refreshCustomerDetails(function() {
                      if(redemptionOption.amount <= spapi.customer.adjusted_points_balance) {
                        if(cartTotal/100 >= parseFloat(redemptionOption.icon)) {
                          result = swellAPI.buyMultipleWithPoints([redemptionOption], function(){});
                        }
                        else {
                          $(".swell-lds-holder.swell-ring-btn").css("display","none");
                          $("#swell-redeem-btn .btn__content").show();
                          $(".swell-copuon-error").html("Cart should be minimum $"+(redemptionOption.icon) +" for this reward");
                          $(".swell-copuon-error").show();
                        }
                      }
                      else {
                        $(".swell-lds-holder.swell-ring-btn").css("display","none");
                        $("#swell-redeem-btn .btn__content").show();
                        $(".swell-copuon-error").html("Sorry, you don't have enough points for this reward.");
                        $(".swell-copuon-error").show();
                      }
                    });
                  }
                }
              }
            });
            Swell.Cart.items.forEach(function(item) {
              if (item.properties._swell_discount_type == "cart_fixed_amount") {
                redeemedRedemptionOption = swellAPI.findActiveRedemptionOptionById(item.properties._swell_redemption_option_id);
                console.log('swell-0');
                if(swellCheckCart() == false){
                  $(document).on("swell:cart:updated", function(){
                    if(window.location.href.indexOf("cart") > -1) {
                      window.location = "/cart";
                    }
                  });
                  swellAPI.removeRedemptionOptionIdFromCart(redeemedRedemptionOption.id, function(){});
                }
                else if($(".swell-cart-product").length == 0) {
                  console.log('swell-1');
                  $(".cart .cart__row:last").before('<div class="cart__row"> <div class="grid grid--full cart__row--table-large"> <div class="grid__item medium-up--three-fifths"> <div class="grid"> <div class="grid__item one-quarter"> </div> <div class="grid__item three-quarters"> <a href="/products/custom-pit-barrel%C2%AE-chimney-starter?variant=24564447805504" class="h4 cart__product-name"> '+redeemedRedemptionOption.name+' OFF </a> <p class="cart__product-meta"> <a href="javascript:void(0);" class="swell-coupon-remove btn btn--secondary btn--small small--hide"> Remove </a> <a href="javascript:void(0);" class="swell-coupon-remove btn btn--small medium-up--hide"> <small>Remove</small> </a> </p> </div> </div> </div> <div class="grid__item medium-up--two-fifths"> <div class="grid grid--full cart__row--table-large"> <div class="grid__item one-third medium-up--text-right"> <label class="medium-up--hide"> Price </label> <span class="cart__price">'+redeemedRedemptionOption.cost_text+'</span> </div> <div class="grid__item one-third text-center"> <label for="updates_24564447805504:34610319319d09ec9ee1daed6e943103" class="medium-up--hide">Quantity</label> <label for="updates_24564447805504:34610319319d09ec9ee1daed6e943103" class="visually-hidden">Quantity</label> <input type="number" name="updates[]" id="updates_24564447805504:34610319319d09ec9ee1daed6e943103" class="cart__product-qty" value="1" min="0" data-id="24564447805504:34610319319d09ec9ee1daed6e943103" disabled="disabled"> </div> <div class="grid__item one-third text-right"> <label class="medium-up--hide"> Total </label> <span class="cart__price gtapps-cart-item-line-price" qd-data-key="24564447805504:34610319319d09ec9ee1daed6e943103">'+redeemedRedemptionOption.name+' OFF</span> </div> </div> </div> </div> </div>');                
                }
                return
              }
            });
            $('body').on('click',".swell-coupon-remove", function() {
              $(document).on("swell:cart:updated", function(){
                if(window.location.href.indexOf("cart") > -1) {
                  window.location = "/cart";
                }
                else{
                  $(temp_holder).html(temp);
                  spapi.$.confirm({
                    title: "Redeemed!",
                    content: "You have redeemed the discount!",
                    type: "green",
                    typeAnimated: true,
                    useBootstrap: false,
                    boxWidth: "400px",
                    buttons: {
                      ok: {
                        text: "Ok",
                        action: function () {
                        }
                      }
                    }
                  });
                }
              });
              $(".swell-coupon-remove").html('<div class="swell-lds-holder swell-ring-remove"><div class="swell-lds-dual-ring swell-ring-remove"></div></div>');
              swellAPI.removeRedemptionOptionIdFromCart(redeemedRedemptionOption.id, function(){});
            });
          }
        });
      });  
      stop();
    }
  }
  function stop() {
    clearInterval(myVar);
  }
}).call(this);

//redemptions
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Redemption = {
    cartRedemptions: function(containerSelector) {
      var optionTmpl = '';
      var redemptions = spapi.activeRedemptionOptions;
      if($(containerSelector + " option").length == 0) {
        redemptions.forEach(function(redemption) {
          if(redemption.discount_type == "cart_fixed_amount") {
            $(containerSelector).append('<option value="'+ redemption.id +'" >'+redemption.name+' ('+ redemption.cost_text +'), Minimum Cart $'+ redemption.icon +' </option>');
          }
        });
        $(containerSelector).prepend("<option value='choose'>Choose your reward</option>");
      }
    },
    cartRedemptionsShow: function () {
      $(".swell-checkout").css("display", "flex");
    },
    cartRedemptionDropdown: function (containerSelector) {
      $(containerSelector).val("choose");
      SwellConfig.Redemption.cartRedemptionDropdownUpdate(containerSelector);
      $(containerSelector).on('change', function() {
        SwellConfig.Redemption.cartRedemptionDropdownUpdate(containerSelector);
      });
    },
    cartRedemptionDropdownUpdate: function (containerSelector) {
      if($(containerSelector).val()=='choose' || $(containerSelector).val() == undefined){
        $("#swell-redeem-btn").attr("disabled", "disabled");
        $("#swell-redeem-btn").css("opacity","0.8");
      }
      else{
        $("#swell-redeem-btn").removeAttr("disabled");
        $("#swell-redeem-btn").css("opacity","1");
      }
    }
  };
}).call(this);

function beforeDiscountRedemption(){
  var redeemedItemsInCart = 0;
  var regularItemsInCart = 0;
  var discountInCart = 0;

  if(Swell.Cart && Swell.Cart.items){
    var cart = Swell.Cart;

    $.each(cart.items, function(index, item){
      if(item.properties._swell_points_used){
        redeemedItemsInCart++;
      } else if(item.line_price > 0){
        regularItemsInCart++; 
      }
    });

    Swell.Cart.items.forEach(function(item) {
      if (item.properties._swell_discount_type == "cart_fixed_amount") {
        discountInCart++;
      }
    });
    if(discountInCart > 0){
      $(".swell-copuon-error").html("You already have a redeemed discount in your cart.")
      $(".swell-copuon-error").show();
      return false;
    }
    else if(regularItemsInCart == 0){
      spapi.$.confirm({
        title: "Oops!",
        content: "You must add a priced item in your cart to redeem points for a discount.",
        type: "red",
        typeAnimated: true,
        useBootstrap: false,
        boxWidth: "400px",
        buttons: {
          ok: {
            text: "Ok",
            action: function () {
            }
          }
        }
      });
      return false;
    }
    else{
      return true;
    }
  }
};

function swellCheckCart() {
  var cart_Total = 0;
  var legal = true;
  Swell.Cart.items.forEach(function(item) {
    cart_Total+= item.original_price * item.quantity;
  });
  Swell.Cart.items.forEach(function(item) {
    if (item.properties._swell_discount_type == "cart_fixed_amount") {
      redeemedRedemptionOption = swellAPI.findActiveRedemptionOptionById(item.properties._swell_redemption_option_id);
      if(parseFloat(redeemedRedemptionOption.icon) > cart_Total/100){
        legal = false;
      }
    }
  });
  return legal;
}